// Hideo - words of a text and the time to say or read them: the script's counter, the Shorts, the SEO checks and the
// editor all use these
/** Spoken speed of a script: words per second */
export const WORDS_PER_SEC = 2.5
/** Reading speed of an article: words per minute */
export const READ_WPM = 200
/** Number of words (anything between spaces) */
export const countWords = (text: unknown): number => (String(text || '').match(/\S+/g) || []).length
/** Spoken seconds of a number of words, rounded */
export const spokenSec = (words: number): number => Math.round(words / WORDS_PER_SEC)
